import { getSocialAvatarBadge } from "Components/Social/MerchantAvatarBadge";
import {
  SocialUserRow,
  type Props as SocialUserRowProps,
} from "Components/Social/SocialUserRow";
import type { SocialUserSummary } from "Infrastructure/Api/Api";
import { getContextProfilePhotoUrl } from "Utils/Image/getProfilePhotoUrl";

type Props = Omit<
  SocialUserRowProps,
  "identityUserPublicID" | "handle" | "displayName" | "avatarUrl"
> & {
  /**
   * The persona as the social endpoints project it. `SocialUserSearchDto` is structurally the
   * same shape, so search results pass straight through.
   */
  user: SocialUserSummary;
};

/**
 * SocialUserRow fed from a social summary: identity, handle, the per-persona avatar URL and the
 * merchant badge all derive from the DTO, so a list host only supplies what differs per list —
 * the `action` controls, or a picker's `marker`/`onSelect`. `avatarBadge` can still be
 * overridden (the chat picker shows a role badge instead of the storefront one).
 */
export const SocialSummaryRow = ({
  user: {
    identityUserPublicID,
    handle,
    displayName,
    profilePicture,
    accessRoleCode,
  },
  avatarBadge,
  ...rowProps
}: Props) => (
  <SocialUserRow
    identityUserPublicID={identityUserPublicID}
    handle={handle}
    displayName={displayName}
    avatarUrl={getContextProfilePhotoUrl(identityUserPublicID, profilePicture)}
    avatarBadge={avatarBadge ?? getSocialAvatarBadge(accessRoleCode)}
    {...rowProps}
  />
);
